// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Simple-Line-Icons.eot?-i3a2kk", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Simple-Line-Icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Simple-Line-Icons.ttf?-i3a2kk", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Simple-Line-Icons.woff2?-i3a2kk", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Simple-Line-Icons.woff?-i3a2kk", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Simple-Line-Icons.svg?-i3a2kk", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix-i3a2kk" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "#simple-line-icons" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "simple-line-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/*
 Use the following CSS code if you want to have a class per icon.
 Instead of a list of all class selectors, you can use the generic [class*="sl-icon-"] selector, but it's slower: 
*/
.sl-icon-user,
.sl-icon-people,
.sl-icon-user-female,
.sl-icon-user-follow,
.sl-icon-user-following,
.sl-icon-user-unfollow,
.sl-icon-login,
.sl-icon-logout,
.sl-icon-emotsmile,
.sl-icon-phone,
.sl-icon-call-end,
.sl-icon-call-in,
.sl-icon-call-out,
.sl-icon-map,
.sl-icon-location-pin,
.sl-icon-direction,
.sl-icon-directions,
.sl-icon-compass,
.sl-icon-layers,
.sl-icon-menu,
.sl-icon-list,
.sl-icon-options-vertical,
.sl-icon-options,
.sl-icon-arrow-down,
.sl-icon-arrow-left,
.sl-icon-arrow-right,
.sl-icon-arrow-up,
.sl-icon-arrow-up-circle,
.sl-icon-arrow-left-circle,
.sl-icon-arrow-right-circle,
.sl-icon-arrow-down-circle,
.sl-icon-check,
.sl-icon-clock,
.sl-icon-plus,
.sl-icon-close,
.sl-icon-trophy,
.sl-icon-screen-smartphone,
.sl-icon-screen-desktop,
.sl-icon-plane,
.sl-icon-notebook,
.sl-icon-mustache,
.sl-icon-mouse,
.sl-icon-magnet,
.sl-icon-energy,
.sl-icon-disc,
.sl-icon-cursor,
.sl-icon-cursor-move,
.sl-icon-crop,
.sl-icon-chemistry,
.sl-icon-speedometer,
.sl-icon-shield,
.sl-icon-screen-tablet,
.sl-icon-magic-wand,
.sl-icon-hourglass,
.sl-icon-graduation,
.sl-icon-ghost,
.sl-icon-game-controller,
.sl-icon-fire,
.sl-icon-eyeglass,
.sl-icon-envelope-open,
.sl-icon-envelope-letter,
.sl-icon-bell,
.sl-icon-badge,
.sl-icon-anchor,
.sl-icon-wallet,
.sl-icon-vector,
.sl-icon-speech,
.sl-icon-puzzle,
.sl-icon-printer,
.sl-icon-present,
.sl-icon-playlist,
.sl-icon-pin,
.sl-icon-picture,
.sl-icon-handbag,
.sl-icon-globe-alt,
.sl-icon-globe,
.sl-icon-folder-alt,
.sl-icon-folder,
.sl-icon-film,
.sl-icon-feed,
.sl-icon-drop,
.sl-icon-drawar,
.sl-icon-docs,
.sl-icon-doc,
.sl-icon-diamond,
.sl-icon-cup,
.sl-icon-calculator,
.sl-icon-bubbles,
.sl-icon-briefcase,
.sl-icon-book-open,
.sl-icon-basket-loaded,
.sl-icon-basket,
.sl-icon-bag,
.sl-icon-action-undo,
.sl-icon-action-redo,
.sl-icon-wrench,
.sl-icon-umbrella,
.sl-icon-trash,
.sl-icon-tag,
.sl-icon-support,
.sl-icon-frame,
.sl-icon-size-fullscreen,
.sl-icon-size-actual,
.sl-icon-shuffle,
.sl-icon-share-alt,
.sl-icon-share,
.sl-icon-rocket,
.sl-icon-question,
.sl-icon-pie-chart,
.sl-icon-pencil,
.sl-icon-note,
.sl-icon-loop,
.sl-icon-home,
.sl-icon-grid,
.sl-icon-graph,
.sl-icon-microphone,
.sl-icon-music-tone-alt,
.sl-icon-music-tone,
.sl-icon-earphones-alt,
.sl-icon-earphones,
.sl-icon-equalizer,
.sl-icon-like,
.sl-icon-dislike,
.sl-icon-control-start,
.sl-icon-control-rewind,
.sl-icon-control-play,
.sl-icon-control-pause,
.sl-icon-control-forward,
.sl-icon-control-end,
.sl-icon-volume-1,
.sl-icon-volume-2,
.sl-icon-volume-off,
.sl-icon-calender,
.sl-icon-bulb,
.sl-icon-chart,
.sl-icon-ban,
.sl-icon-bubble,
.sl-icon-camrecorder,
.sl-icon-camera,
.sl-icon-cloud-download,
.sl-icon-cloud-upload,
.sl-icon-envelope,
.sl-icon-eye,
.sl-icon-flag,
.sl-icon-heart,
.sl-icon-info,
.sl-icon-key,
.sl-icon-link,
.sl-icon-lock,
.sl-icon-lock-open,
.sl-icon-magnifier,
.sl-icon-magnifier-add,
.sl-icon-magnifier-remove,
.sl-icon-paper-clip,
.sl-icon-paper-plane,
.sl-icon-power,
.sl-icon-refresh,
.sl-icon-reload,
.sl-icon-settings,
.sl-icon-star,
.sl-icon-symble-female,
.sl-icon-symbol-male,
.sl-icon-target,
.sl-icon-credit-card,
.sl-icon-paypal,
.sl-icon-social-tumblr,
.sl-icon-social-twitter,
.sl-icon-social-facebook,
.sl-icon-social-instagram,
.sl-icon-social-linkedin,
.sl-icon-social-pintarest,
.sl-icon-social-github,
.sl-icon-social-gplus,
.sl-icon-social-reddit,
.sl-icon-social-skype,
.sl-icon-social-dribbble,
.sl-icon-social-behance,
.sl-icon-social-foursqare,
.sl-icon-social-soundcloud,
.sl-icon-social-spotify,
.sl-icon-social-stumbleupon,
.sl-icon-social-youtube,
.sl-icon-social-dropbox {
  font-family: "simple-line-icons";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sl-icon-user:before {
  content: "\\e005";
}

.sl-icon-people:before {
  content: "\\e001";
}

.sl-icon-user-female:before {
  content: "\\e000";
}

.sl-icon-user-follow:before {
  content: "\\e002";
}

.sl-icon-user-following:before {
  content: "\\e003";
}

.sl-icon-user-unfollow:before {
  content: "\\e004";
}

.sl-icon-login:before {
  content: "\\e066";
}

.sl-icon-logout:before {
  content: "\\e065";
}

.sl-icon-emotsmile:before {
  content: "\\e021";
}

.sl-icon-phone:before {
  content: "\\e600";
}

.sl-icon-call-end:before {
  content: "\\e048";
}

.sl-icon-call-in:before {
  content: "\\e047";
}

.sl-icon-call-out:before {
  content: "\\e046";
}

.sl-icon-map:before {
  content: "\\e033";
}

.sl-icon-location-pin:before {
  content: "\\e096";
}

.sl-icon-direction:before {
  content: "\\e042";
}

.sl-icon-directions:before {
  content: "\\e041";
}

.sl-icon-compass:before {
  content: "\\e045";
}

.sl-icon-layers:before {
  content: "\\e034";
}

.sl-icon-menu:before {
  content: "\\e601";
}

.sl-icon-list:before {
  content: "\\e067";
}

.sl-icon-options-vertical:before {
  content: "\\e602";
}

.sl-icon-options:before {
  content: "\\e603";
}

.sl-icon-arrow-down:before {
  content: "\\e604";
}

.sl-icon-arrow-left:before {
  content: "\\e605";
}

.sl-icon-arrow-right:before {
  content: "\\e606";
}

.sl-icon-arrow-up:before {
  content: "\\e607";
}

.sl-icon-arrow-up-circle:before {
  content: "\\e078";
}

.sl-icon-arrow-left-circle:before {
  content: "\\e07a";
}

.sl-icon-arrow-right-circle:before {
  content: "\\e079";
}

.sl-icon-arrow-down-circle:before {
  content: "\\e07b";
}

.sl-icon-check:before {
  content: "\\e080";
}

.sl-icon-clock:before {
  content: "\\e081";
}

.sl-icon-plus:before {
  content: "\\e095";
}

.sl-icon-close:before {
  content: "\\e082";
}

.sl-icon-trophy:before {
  content: "\\e006";
}

.sl-icon-screen-smartphone:before {
  content: "\\e010";
}

.sl-icon-screen-desktop:before {
  content: "\\e011";
}

.sl-icon-plane:before {
  content: "\\e012";
}

.sl-icon-notebook:before {
  content: "\\e013";
}

.sl-icon-mustache:before {
  content: "\\e014";
}

.sl-icon-mouse:before {
  content: "\\e015";
}

.sl-icon-magnet:before {
  content: "\\e016";
}

.sl-icon-energy:before {
  content: "\\e020";
}

.sl-icon-disc:before {
  content: "\\e022";
}

.sl-icon-cursor:before {
  content: "\\e06e";
}

.sl-icon-cursor-move:before {
  content: "\\e023";
}

.sl-icon-crop:before {
  content: "\\e024";
}

.sl-icon-chemistry:before {
  content: "\\e026";
}

.sl-icon-speedometer:before {
  content: "\\e007";
}

.sl-icon-shield:before {
  content: "\\e00e";
}

.sl-icon-screen-tablet:before {
  content: "\\e00f";
}

.sl-icon-magic-wand:before {
  content: "\\e017";
}

.sl-icon-hourglass:before {
  content: "\\e018";
}

.sl-icon-graduation:before {
  content: "\\e019";
}

.sl-icon-ghost:before {
  content: "\\e01a";
}

.sl-icon-game-controller:before {
  content: "\\e01b";
}

.sl-icon-fire:before {
  content: "\\e01c";
}

.sl-icon-eyeglass:before {
  content: "\\e01d";
}

.sl-icon-envelope-open:before {
  content: "\\e01e";
}

.sl-icon-envelope-letter:before {
  content: "\\e01f";
}

.sl-icon-bell:before {
  content: "\\e027";
}

.sl-icon-badge:before {
  content: "\\e028";
}

.sl-icon-anchor:before {
  content: "\\e029";
}

.sl-icon-wallet:before {
  content: "\\e02a";
}

.sl-icon-vector:before {
  content: "\\e02b";
}

.sl-icon-speech:before {
  content: "\\e02c";
}

.sl-icon-puzzle:before {
  content: "\\e02d";
}

.sl-icon-printer:before {
  content: "\\e02e";
}

.sl-icon-present:before {
  content: "\\e02f";
}

.sl-icon-playlist:before {
  content: "\\e030";
}

.sl-icon-pin:before {
  content: "\\e031";
}

.sl-icon-picture:before {
  content: "\\e032";
}

.sl-icon-handbag:before {
  content: "\\e035";
}

.sl-icon-globe-alt:before {
  content: "\\e036";
}

.sl-icon-globe:before {
  content: "\\e037";
}

.sl-icon-folder-alt:before {
  content: "\\e039";
}

.sl-icon-folder:before {
  content: "\\e089";
}

.sl-icon-film:before {
  content: "\\e03a";
}

.sl-icon-feed:before {
  content: "\\e03b";
}

.sl-icon-drop:before {
  content: "\\e03e";
}

.sl-icon-drawar:before {
  content: "\\e03f";
}

.sl-icon-docs:before {
  content: "\\e040";
}

.sl-icon-doc:before {
  content: "\\e085";
}

.sl-icon-diamond:before {
  content: "\\e043";
}

.sl-icon-cup:before {
  content: "\\e044";
}

.sl-icon-calculator:before {
  content: "\\e049";
}

.sl-icon-bubbles:before {
  content: "\\e04a";
}

.sl-icon-briefcase:before {
  content: "\\e04b";
}

.sl-icon-book-open:before {
  content: "\\e04c";
}

.sl-icon-basket-loaded:before {
  content: "\\e04d";
}

.sl-icon-basket:before {
  content: "\\e04e";
}

.sl-icon-bag:before {
  content: "\\e04f";
}

.sl-icon-action-undo:before {
  content: "\\e050";
}

.sl-icon-action-redo:before {
  content: "\\e051";
}

.sl-icon-wrench:before {
  content: "\\e052";
}

.sl-icon-umbrella:before {
  content: "\\e053";
}

.sl-icon-trash:before {
  content: "\\e054";
}

.sl-icon-tag:before {
  content: "\\e055";
}

.sl-icon-support:before {
  content: "\\e056";
}

.sl-icon-frame:before {
  content: "\\e038";
}

.sl-icon-size-fullscreen:before {
  content: "\\e057";
}

.sl-icon-size-actual:before {
  content: "\\e058";
}

.sl-icon-shuffle:before {
  content: "\\e059";
}

.sl-icon-share-alt:before {
  content: "\\e05a";
}

.sl-icon-share:before {
  content: "\\e05b";
}

.sl-icon-rocket:before {
  content: "\\e05c";
}

.sl-icon-question:before {
  content: "\\e05d";
}

.sl-icon-pie-chart:before {
  content: "\\e05e";
}

.sl-icon-pencil:before {
  content: "\\e05f";
}

.sl-icon-note:before {
  content: "\\e060";
}

.sl-icon-loop:before {
  content: "\\e064";
}

.sl-icon-home:before {
  content: "\\e069";
}

.sl-icon-grid:before {
  content: "\\e06a";
}

.sl-icon-graph:before {
  content: "\\e06b";
}

.sl-icon-microphone:before {
  content: "\\e063";
}

.sl-icon-music-tone-alt:before {
  content: "\\e061";
}

.sl-icon-music-tone:before {
  content: "\\e062";
}

.sl-icon-earphones-alt:before {
  content: "\\e03c";
}

.sl-icon-earphones:before {
  content: "\\e03d";
}

.sl-icon-equalizer:before {
  content: "\\e06c";
}

.sl-icon-like:before {
  content: "\\e068";
}

.sl-icon-dislike:before {
  content: "\\e06d";
}

.sl-icon-control-start:before {
  content: "\\e06f";
}

.sl-icon-control-rewind:before {
  content: "\\e070";
}

.sl-icon-control-play:before {
  content: "\\e071";
}

.sl-icon-control-pause:before {
  content: "\\e072";
}

.sl-icon-control-forward:before {
  content: "\\e073";
}

.sl-icon-control-end:before {
  content: "\\e074";
}

.sl-icon-volume-1:before {
  content: "\\e09f";
}

.sl-icon-volume-2:before {
  content: "\\e0a0";
}

.sl-icon-volume-off:before {
  content: "\\e0a1";
}

.sl-icon-calender:before {
  content: "\\e075";
}

.sl-icon-bulb:before {
  content: "\\e076";
}

.sl-icon-chart:before {
  content: "\\e077";
}

.sl-icon-ban:before {
  content: "\\e07c";
}

.sl-icon-bubble:before {
  content: "\\e07d";
}

.sl-icon-camrecorder:before {
  content: "\\e07e";
}

.sl-icon-camera:before {
  content: "\\e07f";
}

.sl-icon-cloud-download:before {
  content: "\\e083";
}

.sl-icon-cloud-upload:before {
  content: "\\e084";
}

.sl-icon-envelope:before {
  content: "\\e086";
}

.sl-icon-eye:before {
  content: "\\e087";
}

.sl-icon-flag:before {
  content: "\\e088";
}

.sl-icon-heart:before {
  content: "\\e08a";
}

.sl-icon-info:before {
  content: "\\e08b";
}

.sl-icon-key:before {
  content: "\\e08c";
}

.sl-icon-link:before {
  content: "\\e08d";
}

.sl-icon-lock:before {
  content: "\\e08e";
}

.sl-icon-lock-open:before {
  content: "\\e08f";
}

.sl-icon-magnifier:before {
  content: "\\e090";
}

.sl-icon-magnifier-add:before {
  content: "\\e091";
}

.sl-icon-magnifier-remove:before {
  content: "\\e092";
}

.sl-icon-paper-clip:before {
  content: "\\e093";
}

.sl-icon-paper-plane:before {
  content: "\\e094";
}

.sl-icon-power:before {
  content: "\\e097";
}

.sl-icon-refresh:before {
  content: "\\e098";
}

.sl-icon-reload:before {
  content: "\\e099";
}

.sl-icon-settings:before {
  content: "\\e09a";
}

.sl-icon-star:before {
  content: "\\e09b";
}

.sl-icon-symble-female:before {
  content: "\\e09c";
}

.sl-icon-symbol-male:before {
  content: "\\e09d";
}

.sl-icon-target:before {
  content: "\\e09e";
}

.sl-icon-credit-card:before {
  content: "\\e025";
}

.sl-icon-paypal:before {
  content: "\\e608";
}

.sl-icon-social-tumblr:before {
  content: "\\e00a";
}

.sl-icon-social-twitter:before {
  content: "\\e009";
}

.sl-icon-social-facebook:before {
  content: "\\e00b";
}

.sl-icon-social-instagram:before {
  content: "\\e609";
}

.sl-icon-social-linkedin:before {
  content: "\\e60a";
}

.sl-icon-social-pintarest:before {
  content: "\\e60b";
}

.sl-icon-social-github:before {
  content: "\\e60c";
}

.sl-icon-social-gplus:before {
  content: "\\e60d";
}

.sl-icon-social-reddit:before {
  content: "\\e60e";
}

.sl-icon-social-skype:before {
  content: "\\e60f";
}

.sl-icon-social-dribbble:before {
  content: "\\e00d";
}

.sl-icon-social-behance:before {
  content: "\\e610";
}

.sl-icon-social-foursqare:before {
  content: "\\e611";
}

.sl-icon-social-soundcloud:before {
  content: "\\e612";
}

.sl-icon-social-spotify:before {
  content: "\\e613";
}

.sl-icon-social-stumbleupon:before {
  content: "\\e614";
}

.sl-icon-social-youtube:before {
  content: "\\e008";
}

.sl-icon-social-dropbox:before {
  content: "\\e00c";
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/icons/simple-line-icons/css/simple-line-icons.css"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,4CAAA;EACA,4SAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACA;;;CAAA;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAuLE,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,sCAAA;EACA,mCAAA;EACA,kCAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,gBAAA;AAGF;;AADA;EACE,gBAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,gBAAA;AAMF;;AAJA;EACE,gBAAA;AAOF;;AALA;EACE,gBAAA;AAQF;;AANA;EACE,gBAAA;AASF;;AAPA;EACE,gBAAA;AAUF;;AARA;EACE,gBAAA;AAWF;;AATA;EACE,gBAAA;AAYF;;AAVA;EACE,gBAAA;AAaF;;AAXA;EACE,gBAAA;AAcF;;AAZA;EACE,gBAAA;AAeF;;AAbA;EACE,gBAAA;AAgBF;;AAdA;EACE,gBAAA;AAiBF;;AAfA;EACE,gBAAA;AAkBF;;AAhBA;EACE,gBAAA;AAmBF;;AAjBA;EACE,gBAAA;AAoBF;;AAlBA;EACE,gBAAA;AAqBF;;AAnBA;EACE,gBAAA;AAsBF;;AApBA;EACE,gBAAA;AAuBF;;AArBA;EACE,gBAAA;AAwBF;;AAtBA;EACE,gBAAA;AAyBF;;AAvBA;EACE,gBAAA;AA0BF;;AAxBA;EACE,gBAAA;AA2BF;;AAzBA;EACE,gBAAA;AA4BF;;AA1BA;EACE,gBAAA;AA6BF;;AA3BA;EACE,gBAAA;AA8BF;;AA5BA;EACE,gBAAA;AA+BF;;AA7BA;EACE,gBAAA;AAgCF;;AA9BA;EACE,gBAAA;AAiCF;;AA/BA;EACE,gBAAA;AAkCF;;AAhCA;EACE,gBAAA;AAmCF;;AAjCA;EACE,gBAAA;AAoCF;;AAlCA;EACE,gBAAA;AAqCF;;AAnCA;EACE,gBAAA;AAsCF;;AApCA;EACE,gBAAA;AAuCF;;AArCA;EACE,gBAAA;AAwCF;;AAtCA;EACE,gBAAA;AAyCF;;AAvCA;EACE,gBAAA;AA0CF;;AAxCA;EACE,gBAAA;AA2CF;;AAzCA;EACE,gBAAA;AA4CF;;AA1CA;EACE,gBAAA;AA6CF;;AA3CA;EACE,gBAAA;AA8CF;;AA5CA;EACE,gBAAA;AA+CF;;AA7CA;EACE,gBAAA;AAgDF;;AA9CA;EACE,gBAAA;AAiDF;;AA/CA;EACE,gBAAA;AAkDF;;AAhDA;EACE,gBAAA;AAmDF;;AAjDA;EACE,gBAAA;AAoDF;;AAlDA;EACE,gBAAA;AAqDF;;AAnDA;EACE,gBAAA;AAsDF;;AApDA;EACE,gBAAA;AAuDF;;AArDA;EACE,gBAAA;AAwDF;;AAtDA;EACE,gBAAA;AAyDF;;AAvDA;EACE,gBAAA;AA0DF;;AAxDA;EACE,gBAAA;AA2DF;;AAzDA;EACE,gBAAA;AA4DF;;AA1DA;EACE,gBAAA;AA6DF;;AA3DA;EACE,gBAAA;AA8DF;;AA5DA;EACE,gBAAA;AA+DF;;AA7DA;EACE,gBAAA;AAgEF;;AA9DA;EACE,gBAAA;AAiEF;;AA/DA;EACE,gBAAA;AAkEF;;AAhEA;EACE,gBAAA;AAmEF;;AAjEA;EACE,gBAAA;AAoEF;;AAlEA;EACE,gBAAA;AAqEF;;AAnEA;EACE,gBAAA;AAsEF;;AApEA;EACE,gBAAA;AAuEF;;AArEA;EACE,gBAAA;AAwEF;;AAtEA;EACE,gBAAA;AAyEF;;AAvEA;EACE,gBAAA;AA0EF;;AAxEA;EACE,gBAAA;AA2EF;;AAzEA;EACE,gBAAA;AA4EF;;AA1EA;EACE,gBAAA;AA6EF;;AA3EA;EACE,gBAAA;AA8EF;;AA5EA;EACE,gBAAA;AA+EF;;AA7EA;EACE,gBAAA;AAgFF;;AA9EA;EACE,gBAAA;AAiFF;;AA/EA;EACE,gBAAA;AAkFF;;AAhFA;EACE,gBAAA;AAmFF;;AAjFA;EACE,gBAAA;AAoFF;;AAlFA;EACE,gBAAA;AAqFF;;AAnFA;EACE,gBAAA;AAsFF;;AApFA;EACE,gBAAA;AAuFF;;AArFA;EACE,gBAAA;AAwFF;;AAtFA;EACE,gBAAA;AAyFF;;AAvFA;EACE,gBAAA;AA0FF;;AAxFA;EACE,gBAAA;AA2FF;;AAzFA;EACE,gBAAA;AA4FF;;AA1FA;EACE,gBAAA;AA6FF;;AA3FA;EACE,gBAAA;AA8FF;;AA5FA;EACE,gBAAA;AA+FF;;AA7FA;EACE,gBAAA;AAgGF;;AA9FA;EACE,gBAAA;AAiGF;;AA/FA;EACE,gBAAA;AAkGF;;AAhGA;EACE,gBAAA;AAmGF;;AAjGA;EACE,gBAAA;AAoGF;;AAlGA;EACE,gBAAA;AAqGF;;AAnGA;EACE,gBAAA;AAsGF;;AApGA;EACE,gBAAA;AAuGF;;AArGA;EACE,gBAAA;AAwGF;;AAtGA;EACE,gBAAA;AAyGF;;AAvGA;EACE,gBAAA;AA0GF;;AAxGA;EACE,gBAAA;AA2GF;;AAzGA;EACE,gBAAA;AA4GF;;AA1GA;EACE,gBAAA;AA6GF;;AA3GA;EACE,gBAAA;AA8GF;;AA5GA;EACE,gBAAA;AA+GF;;AA7GA;EACE,gBAAA;AAgHF;;AA9GA;EACE,gBAAA;AAiHF;;AA/GA;EACE,gBAAA;AAkHF;;AAhHA;EACE,gBAAA;AAmHF;;AAjHA;EACE,gBAAA;AAoHF;;AAlHA;EACE,gBAAA;AAqHF;;AAnHA;EACE,gBAAA;AAsHF;;AApHA;EACE,gBAAA;AAuHF;;AArHA;EACE,gBAAA;AAwHF;;AAtHA;EACE,gBAAA;AAyHF;;AAvHA;EACE,gBAAA;AA0HF;;AAxHA;EACE,gBAAA;AA2HF;;AAzHA;EACE,gBAAA;AA4HF;;AA1HA;EACE,gBAAA;AA6HF;;AA3HA;EACE,gBAAA;AA8HF;;AA5HA;EACE,gBAAA;AA+HF;;AA7HA;EACE,gBAAA;AAgIF;;AA9HA;EACE,gBAAA;AAiIF;;AA/HA;EACE,gBAAA;AAkIF;;AAhIA;EACE,gBAAA;AAmIF;;AAjIA;EACE,gBAAA;AAoIF;;AAlIA;EACE,gBAAA;AAqIF;;AAnIA;EACE,gBAAA;AAsIF;;AApIA;EACE,gBAAA;AAuIF;;AArIA;EACE,gBAAA;AAwIF;;AAtIA;EACE,gBAAA;AAyIF;;AAvIA;EACE,gBAAA;AA0IF;;AAxIA;EACE,gBAAA;AA2IF;;AAzIA;EACE,gBAAA;AA4IF;;AA1IA;EACE,gBAAA;AA6IF;;AA3IA;EACE,gBAAA;AA8IF;;AA5IA;EACE,gBAAA;AA+IF;;AA7IA;EACE,gBAAA;AAgJF;;AA9IA;EACE,gBAAA;AAiJF;;AA/IA;EACE,gBAAA;AAkJF;;AAhJA;EACE,gBAAA;AAmJF;;AAjJA;EACE,gBAAA;AAoJF;;AAlJA;EACE,gBAAA;AAqJF;;AAnJA;EACE,gBAAA;AAsJF;;AApJA;EACE,gBAAA;AAuJF;;AArJA;EACE,gBAAA;AAwJF;;AAtJA;EACE,gBAAA;AAyJF;;AAvJA;EACE,gBAAA;AA0JF;;AAxJA;EACE,gBAAA;AA2JF;;AAzJA;EACE,gBAAA;AA4JF;;AA1JA;EACE,gBAAA;AA6JF;;AA3JA;EACE,gBAAA;AA8JF;;AA5JA;EACE,gBAAA;AA+JF;;AA7JA;EACE,gBAAA;AAgKF;;AA9JA;EACE,gBAAA;AAiKF;;AA/JA;EACE,gBAAA;AAkKF;;AAhKA;EACE,gBAAA;AAmKF;;AAjKA;EACE,gBAAA;AAoKF;;AAlKA;EACE,gBAAA;AAqKF;;AAnKA;EACE,gBAAA;AAsKF;;AApKA;EACE,gBAAA;AAuKF;;AArKA;EACE,gBAAA;AAwKF;;AAtKA;EACE,gBAAA;AAyKF;;AAvKA;EACE,gBAAA;AA0KF;;AAxKA;EACE,gBAAA;AA2KF;;AAzKA;EACE,gBAAA;AA4KF;;AA1KA;EACE,gBAAA;AA6KF;;AA3KA;EACE,gBAAA;AA8KF;;AA5KA;EACE,gBAAA;AA+KF;;AA7KA;EACE,gBAAA;AAgLF;;AA9KA;EACE,gBAAA;AAiLF;;AA/KA;EACE,gBAAA;AAkLF;;AAhLA;EACE,gBAAA;AAmLF;;AAjLA;EACE,gBAAA;AAoLF;;AAlLA;EACE,gBAAA;AAqLF;;AAnLA;EACE,gBAAA;AAsLF;;AApLA;EACE,gBAAA;AAuLF;;AArLA;EACE,gBAAA;AAwLF","sourcesContent":["@font-face {\n  font-family: 'simple-line-icons';\n  src: url('..//fonts/Simple-Line-Icons.eot?-i3a2kk');\n  src: url('..//fonts/Simple-Line-Icons.eot?#iefix-i3a2kk') format('embedded-opentype'), url('..//fonts/Simple-Line-Icons.ttf?-i3a2kk') format('truetype'), url('..//fonts/Simple-Line-Icons.woff2?-i3a2kk') format('woff2'), url('..//fonts/Simple-Line-Icons.woff?-i3a2kk') format('woff'), url('..//fonts/Simple-Line-Icons.svg?-i3a2kk#simple-line-icons') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/*\n Use the following CSS code if you want to have a class per icon.\n Instead of a list of all class selectors, you can use the generic [class*=\"sl-icon-\"] selector, but it's slower: \n*/\n.sl-icon-user,\n.sl-icon-people,\n.sl-icon-user-female,\n.sl-icon-user-follow,\n.sl-icon-user-following,\n.sl-icon-user-unfollow,\n.sl-icon-login,\n.sl-icon-logout,\n.sl-icon-emotsmile,\n.sl-icon-phone,\n.sl-icon-call-end,\n.sl-icon-call-in,\n.sl-icon-call-out,\n.sl-icon-map,\n.sl-icon-location-pin,\n.sl-icon-direction,\n.sl-icon-directions,\n.sl-icon-compass,\n.sl-icon-layers,\n.sl-icon-menu,\n.sl-icon-list,\n.sl-icon-options-vertical,\n.sl-icon-options,\n.sl-icon-arrow-down,\n.sl-icon-arrow-left,\n.sl-icon-arrow-right,\n.sl-icon-arrow-up,\n.sl-icon-arrow-up-circle,\n.sl-icon-arrow-left-circle,\n.sl-icon-arrow-right-circle,\n.sl-icon-arrow-down-circle,\n.sl-icon-check,\n.sl-icon-clock,\n.sl-icon-plus,\n.sl-icon-close,\n.sl-icon-trophy,\n.sl-icon-screen-smartphone,\n.sl-icon-screen-desktop,\n.sl-icon-plane,\n.sl-icon-notebook,\n.sl-icon-mustache,\n.sl-icon-mouse,\n.sl-icon-magnet,\n.sl-icon-energy,\n.sl-icon-disc,\n.sl-icon-cursor,\n.sl-icon-cursor-move,\n.sl-icon-crop,\n.sl-icon-chemistry,\n.sl-icon-speedometer,\n.sl-icon-shield,\n.sl-icon-screen-tablet,\n.sl-icon-magic-wand,\n.sl-icon-hourglass,\n.sl-icon-graduation,\n.sl-icon-ghost,\n.sl-icon-game-controller,\n.sl-icon-fire,\n.sl-icon-eyeglass,\n.sl-icon-envelope-open,\n.sl-icon-envelope-letter,\n.sl-icon-bell,\n.sl-icon-badge,\n.sl-icon-anchor,\n.sl-icon-wallet,\n.sl-icon-vector,\n.sl-icon-speech,\n.sl-icon-puzzle,\n.sl-icon-printer,\n.sl-icon-present,\n.sl-icon-playlist,\n.sl-icon-pin,\n.sl-icon-picture,\n.sl-icon-handbag,\n.sl-icon-globe-alt,\n.sl-icon-globe,\n.sl-icon-folder-alt,\n.sl-icon-folder,\n.sl-icon-film,\n.sl-icon-feed,\n.sl-icon-drop,\n.sl-icon-drawar,\n.sl-icon-docs,\n.sl-icon-doc,\n.sl-icon-diamond,\n.sl-icon-cup,\n.sl-icon-calculator,\n.sl-icon-bubbles,\n.sl-icon-briefcase,\n.sl-icon-book-open,\n.sl-icon-basket-loaded,\n.sl-icon-basket,\n.sl-icon-bag,\n.sl-icon-action-undo,\n.sl-icon-action-redo,\n.sl-icon-wrench,\n.sl-icon-umbrella,\n.sl-icon-trash,\n.sl-icon-tag,\n.sl-icon-support,\n.sl-icon-frame,\n.sl-icon-size-fullscreen,\n.sl-icon-size-actual,\n.sl-icon-shuffle,\n.sl-icon-share-alt,\n.sl-icon-share,\n.sl-icon-rocket,\n.sl-icon-question,\n.sl-icon-pie-chart,\n.sl-icon-pencil,\n.sl-icon-note,\n.sl-icon-loop,\n.sl-icon-home,\n.sl-icon-grid,\n.sl-icon-graph,\n.sl-icon-microphone,\n.sl-icon-music-tone-alt,\n.sl-icon-music-tone,\n.sl-icon-earphones-alt,\n.sl-icon-earphones,\n.sl-icon-equalizer,\n.sl-icon-like,\n.sl-icon-dislike,\n.sl-icon-control-start,\n.sl-icon-control-rewind,\n.sl-icon-control-play,\n.sl-icon-control-pause,\n.sl-icon-control-forward,\n.sl-icon-control-end,\n.sl-icon-volume-1,\n.sl-icon-volume-2,\n.sl-icon-volume-off,\n.sl-icon-calender,\n.sl-icon-bulb,\n.sl-icon-chart,\n.sl-icon-ban,\n.sl-icon-bubble,\n.sl-icon-camrecorder,\n.sl-icon-camera,\n.sl-icon-cloud-download,\n.sl-icon-cloud-upload,\n.sl-icon-envelope,\n.sl-icon-eye,\n.sl-icon-flag,\n.sl-icon-heart,\n.sl-icon-info,\n.sl-icon-key,\n.sl-icon-link,\n.sl-icon-lock,\n.sl-icon-lock-open,\n.sl-icon-magnifier,\n.sl-icon-magnifier-add,\n.sl-icon-magnifier-remove,\n.sl-icon-paper-clip,\n.sl-icon-paper-plane,\n.sl-icon-power,\n.sl-icon-refresh,\n.sl-icon-reload,\n.sl-icon-settings,\n.sl-icon-star,\n.sl-icon-symble-female,\n.sl-icon-symbol-male,\n.sl-icon-target,\n.sl-icon-credit-card,\n.sl-icon-paypal,\n.sl-icon-social-tumblr,\n.sl-icon-social-twitter,\n.sl-icon-social-facebook,\n.sl-icon-social-instagram,\n.sl-icon-social-linkedin,\n.sl-icon-social-pintarest,\n.sl-icon-social-github,\n.sl-icon-social-gplus,\n.sl-icon-social-reddit,\n.sl-icon-social-skype,\n.sl-icon-social-dribbble,\n.sl-icon-social-behance,\n.sl-icon-social-foursqare,\n.sl-icon-social-soundcloud,\n.sl-icon-social-spotify,\n.sl-icon-social-stumbleupon,\n.sl-icon-social-youtube,\n.sl-icon-social-dropbox {\n  font-family: 'simple-line-icons';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.sl-icon-user:before {\n  content: \"\\e005\";\n}\n.sl-icon-people:before {\n  content: \"\\e001\";\n}\n.sl-icon-user-female:before {\n  content: \"\\e000\";\n}\n.sl-icon-user-follow:before {\n  content: \"\\e002\";\n}\n.sl-icon-user-following:before {\n  content: \"\\e003\";\n}\n.sl-icon-user-unfollow:before {\n  content: \"\\e004\";\n}\n.sl-icon-login:before {\n  content: \"\\e066\";\n}\n.sl-icon-logout:before {\n  content: \"\\e065\";\n}\n.sl-icon-emotsmile:before {\n  content: \"\\e021\";\n}\n.sl-icon-phone:before {\n  content: \"\\e600\";\n}\n.sl-icon-call-end:before {\n  content: \"\\e048\";\n}\n.sl-icon-call-in:before {\n  content: \"\\e047\";\n}\n.sl-icon-call-out:before {\n  content: \"\\e046\";\n}\n.sl-icon-map:before {\n  content: \"\\e033\";\n}\n.sl-icon-location-pin:before {\n  content: \"\\e096\";\n}\n.sl-icon-direction:before {\n  content: \"\\e042\";\n}\n.sl-icon-directions:before {\n  content: \"\\e041\";\n}\n.sl-icon-compass:before {\n  content: \"\\e045\";\n}\n.sl-icon-layers:before {\n  content: \"\\e034\";\n}\n.sl-icon-menu:before {\n  content: \"\\e601\";\n}\n.sl-icon-list:before {\n  content: \"\\e067\";\n}\n.sl-icon-options-vertical:before {\n  content: \"\\e602\";\n}\n.sl-icon-options:before {\n  content: \"\\e603\";\n}\n.sl-icon-arrow-down:before {\n  content: \"\\e604\";\n}\n.sl-icon-arrow-left:before {\n  content: \"\\e605\";\n}\n.sl-icon-arrow-right:before {\n  content: \"\\e606\";\n}\n.sl-icon-arrow-up:before {\n  content: \"\\e607\";\n}\n.sl-icon-arrow-up-circle:before {\n  content: \"\\e078\";\n}\n.sl-icon-arrow-left-circle:before {\n  content: \"\\e07a\";\n}\n.sl-icon-arrow-right-circle:before {\n  content: \"\\e079\";\n}\n.sl-icon-arrow-down-circle:before {\n  content: \"\\e07b\";\n}\n.sl-icon-check:before {\n  content: \"\\e080\";\n}\n.sl-icon-clock:before {\n  content: \"\\e081\";\n}\n.sl-icon-plus:before {\n  content: \"\\e095\";\n}\n.sl-icon-close:before {\n  content: \"\\e082\";\n}\n.sl-icon-trophy:before {\n  content: \"\\e006\";\n}\n.sl-icon-screen-smartphone:before {\n  content: \"\\e010\";\n}\n.sl-icon-screen-desktop:before {\n  content: \"\\e011\";\n}\n.sl-icon-plane:before {\n  content: \"\\e012\";\n}\n.sl-icon-notebook:before {\n  content: \"\\e013\";\n}\n.sl-icon-mustache:before {\n  content: \"\\e014\";\n}\n.sl-icon-mouse:before {\n  content: \"\\e015\";\n}\n.sl-icon-magnet:before {\n  content: \"\\e016\";\n}\n.sl-icon-energy:before {\n  content: \"\\e020\";\n}\n.sl-icon-disc:before {\n  content: \"\\e022\";\n}\n.sl-icon-cursor:before {\n  content: \"\\e06e\";\n}\n.sl-icon-cursor-move:before {\n  content: \"\\e023\";\n}\n.sl-icon-crop:before {\n  content: \"\\e024\";\n}\n.sl-icon-chemistry:before {\n  content: \"\\e026\";\n}\n.sl-icon-speedometer:before {\n  content: \"\\e007\";\n}\n.sl-icon-shield:before {\n  content: \"\\e00e\";\n}\n.sl-icon-screen-tablet:before {\n  content: \"\\e00f\";\n}\n.sl-icon-magic-wand:before {\n  content: \"\\e017\";\n}\n.sl-icon-hourglass:before {\n  content: \"\\e018\";\n}\n.sl-icon-graduation:before {\n  content: \"\\e019\";\n}\n.sl-icon-ghost:before {\n  content: \"\\e01a\";\n}\n.sl-icon-game-controller:before {\n  content: \"\\e01b\";\n}\n.sl-icon-fire:before {\n  content: \"\\e01c\";\n}\n.sl-icon-eyeglass:before {\n  content: \"\\e01d\";\n}\n.sl-icon-envelope-open:before {\n  content: \"\\e01e\";\n}\n.sl-icon-envelope-letter:before {\n  content: \"\\e01f\";\n}\n.sl-icon-bell:before {\n  content: \"\\e027\";\n}\n.sl-icon-badge:before {\n  content: \"\\e028\";\n}\n.sl-icon-anchor:before {\n  content: \"\\e029\";\n}\n.sl-icon-wallet:before {\n  content: \"\\e02a\";\n}\n.sl-icon-vector:before {\n  content: \"\\e02b\";\n}\n.sl-icon-speech:before {\n  content: \"\\e02c\";\n}\n.sl-icon-puzzle:before {\n  content: \"\\e02d\";\n}\n.sl-icon-printer:before {\n  content: \"\\e02e\";\n}\n.sl-icon-present:before {\n  content: \"\\e02f\";\n}\n.sl-icon-playlist:before {\n  content: \"\\e030\";\n}\n.sl-icon-pin:before {\n  content: \"\\e031\";\n}\n.sl-icon-picture:before {\n  content: \"\\e032\";\n}\n.sl-icon-handbag:before {\n  content: \"\\e035\";\n}\n.sl-icon-globe-alt:before {\n  content: \"\\e036\";\n}\n.sl-icon-globe:before {\n  content: \"\\e037\";\n}\n.sl-icon-folder-alt:before {\n  content: \"\\e039\";\n}\n.sl-icon-folder:before {\n  content: \"\\e089\";\n}\n.sl-icon-film:before {\n  content: \"\\e03a\";\n}\n.sl-icon-feed:before {\n  content: \"\\e03b\";\n}\n.sl-icon-drop:before {\n  content: \"\\e03e\";\n}\n.sl-icon-drawar:before {\n  content: \"\\e03f\";\n}\n.sl-icon-docs:before {\n  content: \"\\e040\";\n}\n.sl-icon-doc:before {\n  content: \"\\e085\";\n}\n.sl-icon-diamond:before {\n  content: \"\\e043\";\n}\n.sl-icon-cup:before {\n  content: \"\\e044\";\n}\n.sl-icon-calculator:before {\n  content: \"\\e049\";\n}\n.sl-icon-bubbles:before {\n  content: \"\\e04a\";\n}\n.sl-icon-briefcase:before {\n  content: \"\\e04b\";\n}\n.sl-icon-book-open:before {\n  content: \"\\e04c\";\n}\n.sl-icon-basket-loaded:before {\n  content: \"\\e04d\";\n}\n.sl-icon-basket:before {\n  content: \"\\e04e\";\n}\n.sl-icon-bag:before {\n  content: \"\\e04f\";\n}\n.sl-icon-action-undo:before {\n  content: \"\\e050\";\n}\n.sl-icon-action-redo:before {\n  content: \"\\e051\";\n}\n.sl-icon-wrench:before {\n  content: \"\\e052\";\n}\n.sl-icon-umbrella:before {\n  content: \"\\e053\";\n}\n.sl-icon-trash:before {\n  content: \"\\e054\";\n}\n.sl-icon-tag:before {\n  content: \"\\e055\";\n}\n.sl-icon-support:before {\n  content: \"\\e056\";\n}\n.sl-icon-frame:before {\n  content: \"\\e038\";\n}\n.sl-icon-size-fullscreen:before {\n  content: \"\\e057\";\n}\n.sl-icon-size-actual:before {\n  content: \"\\e058\";\n}\n.sl-icon-shuffle:before {\n  content: \"\\e059\";\n}\n.sl-icon-share-alt:before {\n  content: \"\\e05a\";\n}\n.sl-icon-share:before {\n  content: \"\\e05b\";\n}\n.sl-icon-rocket:before {\n  content: \"\\e05c\";\n}\n.sl-icon-question:before {\n  content: \"\\e05d\";\n}\n.sl-icon-pie-chart:before {\n  content: \"\\e05e\";\n}\n.sl-icon-pencil:before {\n  content: \"\\e05f\";\n}\n.sl-icon-note:before {\n  content: \"\\e060\";\n}\n.sl-icon-loop:before {\n  content: \"\\e064\";\n}\n.sl-icon-home:before {\n  content: \"\\e069\";\n}\n.sl-icon-grid:before {\n  content: \"\\e06a\";\n}\n.sl-icon-graph:before {\n  content: \"\\e06b\";\n}\n.sl-icon-microphone:before {\n  content: \"\\e063\";\n}\n.sl-icon-music-tone-alt:before {\n  content: \"\\e061\";\n}\n.sl-icon-music-tone:before {\n  content: \"\\e062\";\n}\n.sl-icon-earphones-alt:before {\n  content: \"\\e03c\";\n}\n.sl-icon-earphones:before {\n  content: \"\\e03d\";\n}\n.sl-icon-equalizer:before {\n  content: \"\\e06c\";\n}\n.sl-icon-like:before {\n  content: \"\\e068\";\n}\n.sl-icon-dislike:before {\n  content: \"\\e06d\";\n}\n.sl-icon-control-start:before {\n  content: \"\\e06f\";\n}\n.sl-icon-control-rewind:before {\n  content: \"\\e070\";\n}\n.sl-icon-control-play:before {\n  content: \"\\e071\";\n}\n.sl-icon-control-pause:before {\n  content: \"\\e072\";\n}\n.sl-icon-control-forward:before {\n  content: \"\\e073\";\n}\n.sl-icon-control-end:before {\n  content: \"\\e074\";\n}\n.sl-icon-volume-1:before {\n  content: \"\\e09f\";\n}\n.sl-icon-volume-2:before {\n  content: \"\\e0a0\";\n}\n.sl-icon-volume-off:before {\n  content: \"\\e0a1\";\n}\n.sl-icon-calender:before {\n  content: \"\\e075\";\n}\n.sl-icon-bulb:before {\n  content: \"\\e076\";\n}\n.sl-icon-chart:before {\n  content: \"\\e077\";\n}\n.sl-icon-ban:before {\n  content: \"\\e07c\";\n}\n.sl-icon-bubble:before {\n  content: \"\\e07d\";\n}\n.sl-icon-camrecorder:before {\n  content: \"\\e07e\";\n}\n.sl-icon-camera:before {\n  content: \"\\e07f\";\n}\n.sl-icon-cloud-download:before {\n  content: \"\\e083\";\n}\n.sl-icon-cloud-upload:before {\n  content: \"\\e084\";\n}\n.sl-icon-envelope:before {\n  content: \"\\e086\";\n}\n.sl-icon-eye:before {\n  content: \"\\e087\";\n}\n.sl-icon-flag:before {\n  content: \"\\e088\";\n}\n.sl-icon-heart:before {\n  content: \"\\e08a\";\n}\n.sl-icon-info:before {\n  content: \"\\e08b\";\n}\n.sl-icon-key:before {\n  content: \"\\e08c\";\n}\n.sl-icon-link:before {\n  content: \"\\e08d\";\n}\n.sl-icon-lock:before {\n  content: \"\\e08e\";\n}\n.sl-icon-lock-open:before {\n  content: \"\\e08f\";\n}\n.sl-icon-magnifier:before {\n  content: \"\\e090\";\n}\n.sl-icon-magnifier-add:before {\n  content: \"\\e091\";\n}\n.sl-icon-magnifier-remove:before {\n  content: \"\\e092\";\n}\n.sl-icon-paper-clip:before {\n  content: \"\\e093\";\n}\n.sl-icon-paper-plane:before {\n  content: \"\\e094\";\n}\n.sl-icon-power:before {\n  content: \"\\e097\";\n}\n.sl-icon-refresh:before {\n  content: \"\\e098\";\n}\n.sl-icon-reload:before {\n  content: \"\\e099\";\n}\n.sl-icon-settings:before {\n  content: \"\\e09a\";\n}\n.sl-icon-star:before {\n  content: \"\\e09b\";\n}\n.sl-icon-symble-female:before {\n  content: \"\\e09c\";\n}\n.sl-icon-symbol-male:before {\n  content: \"\\e09d\";\n}\n.sl-icon-target:before {\n  content: \"\\e09e\";\n}\n.sl-icon-credit-card:before {\n  content: \"\\e025\";\n}\n.sl-icon-paypal:before {\n  content: \"\\e608\";\n}\n.sl-icon-social-tumblr:before {\n  content: \"\\e00a\";\n}\n.sl-icon-social-twitter:before {\n  content: \"\\e009\";\n}\n.sl-icon-social-facebook:before {\n  content: \"\\e00b\";\n}\n.sl-icon-social-instagram:before {\n  content: \"\\e609\";\n}\n.sl-icon-social-linkedin:before {\n  content: \"\\e60a\";\n}\n.sl-icon-social-pintarest:before {\n  content: \"\\e60b\";\n}\n.sl-icon-social-github:before {\n  content: \"\\e60c\";\n}\n.sl-icon-social-gplus:before {\n  content: \"\\e60d\";\n}\n.sl-icon-social-reddit:before {\n  content: \"\\e60e\";\n}\n.sl-icon-social-skype:before {\n  content: \"\\e60f\";\n}\n.sl-icon-social-dribbble:before {\n  content: \"\\e00d\";\n}\n.sl-icon-social-behance:before {\n  content: \"\\e610\";\n}\n.sl-icon-social-foursqare:before {\n  content: \"\\e611\";\n}\n.sl-icon-social-soundcloud:before {\n  content: \"\\e612\";\n}\n.sl-icon-social-spotify:before {\n  content: \"\\e613\";\n}\n.sl-icon-social-stumbleupon:before {\n  content: \"\\e614\";\n}\n.sl-icon-social-youtube:before {\n  content: \"\\e008\";\n}\n.sl-icon-social-dropbox:before {\n  content: \"\\e00c\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
